import { render } from "./Signup.vue?vue&type=template&id=55a92967"
import script from "./Signup.vue?vue&type=script&lang=js"
export * from "./Signup.vue?vue&type=script&lang=js"

import exportComponent from "/home/github-runner/actions-runner/_work/acutame/acutame/src/main/front/merchant/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__